
import React from 'react';
import { useSelector } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';


import { getProjectStatus } from '../../reducers/project';
import IfComp from '../common/IfComp';
import OverviewPanelOpsub from './OverviewPanelOpsub';
import OverviewPanelAnalyze from './OverviewPanelAnalyze';

const ProjectOverviewContent = ({analyze, projectStatus}) => {

    /*
    const canDisplayOpsub = (
        (katuzeItems.length > 0) &&
        (projectKatuzeItems.length > 0) &&
        (projectStatus === 'SELECT_OPSUB')
    );
    */

    const canDisplayAnalyze = (
        (analyze.loading || analyze.loaded) && (projectStatus === 'SELECT_OPSUB')
    );

    return (
        <Stack verticalFill tokens={{childrenGap: 8}}>
            <Stack horizontal tokens={{childrenGap: 8}}>
                <OverviewPanelOpsub />
            </Stack>
            <Stack.Item grow>
                <IfComp cond={canDisplayAnalyze}>
                    <OverviewPanelAnalyze />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

const AnalyzeVla = () => {

    const projectStatus = useSelector(state => getProjectStatus(state.project));
    const analyze = useSelector(state => state.analyze);

    return (
        <ProjectOverviewContent
            analyze={analyze}
            projectStatus={projectStatus}
        />
    );
}

export default AnalyzeVla;
